import { render, staticRenderFns } from "./sinfo.vue?vue&type=template&id=6d8fcfe3&scoped=true&"
import script from "./sinfo.vue?vue&type=script&lang=js&"
export * from "./sinfo.vue?vue&type=script&lang=js&"
import style0 from "./sinfo.vue?vue&type=style&index=0&id=6d8fcfe3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8fcfe3",
  null
  
)

export default component.exports